export class RouteOptions{
    public static avoidTolls:boolean = false;
    public static historyCheck:boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/RunConfiguration/RouteOptions.ts